import { useNavigate } from "react-router-dom";
import { Lock, Sparkles, Zap, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface UpgradePromptCardProps {
  currentCount: number;
  maxGenies: number;
  className?: string;
}

const UpgradePromptCard = ({ currentCount, maxGenies, className }: UpgradePromptCardProps) => {
  const navigate = useNavigate();

  return (
    <div
      className={cn("p-[2px] rounded-3xl w-full h-full", className)}
      style={{ background: "linear-gradient(135deg, #4E9CFF, #FF4DB8)" }}
    >
      <div className="bg-white rounded-[22px] p-6 relative overflow-hidden flex flex-col items-center justify-center gap-4 h-full min-h-[280px]">
        {/* Background gradient tint */}
        <div
          className="absolute inset-0 opacity-5"
          style={{ background: "linear-gradient(135deg, #4E9CFF 0%, #FF4DB8 100%)" }}
        />

        {/* Lock icon */}
        <div
          className="relative z-10 w-20 h-20 rounded-full flex items-center justify-center"
          style={{ background: "linear-gradient(135deg, #4E9CFF 0%, #FF4DB8 100%)" }}
        >
          <Lock className="w-10 h-10 text-white" />
        </div>

        {/* Content */}
        <div className="relative z-10 text-center space-y-3">
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-2">
              You've Reached Your Genie Limit
            </h3>
            <p className="text-gray-600 text-sm">
              You have <span className="font-semibold text-gray-900">{currentCount} of {maxGenies}</span> genies
            </p>
          </div>

          <div className="space-y-2 py-2">
            {[
              { icon: <Sparkles className="w-4 h-4 text-[#4E9CFF]" />, label: "Create unlimited genies" },
              { icon: <Zap className="w-4 h-4 text-[#9B6DFF]" />, label: "Advanced customization options" },
              { icon: <TrendingUp className="w-4 h-4 text-[#FF4DB8]" />, label: "Priority support & analytics" },
            ].map(({ icon, label }) => (
              <div key={label} className="flex items-center justify-center gap-2 text-sm text-gray-700">
                {icon}
                <span>{label}</span>
              </div>
            ))}
          </div>

          <Button
            onClick={() => navigate("/pricing")}
            size="lg"
            className="text-white font-semibold shadow-lg hover:shadow-xl transition-all"
            style={{ background: "linear-gradient(90deg, #4E9CFF 0%, #FF4DB8 100%)" }}
          >
            Upgrade to Premium
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpgradePromptCard;
